/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ln_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimate the monthly payment on a loan or mortgage, plus the total you'll repay and the interest, from the amount, rate, and term.`)
};

const es_ln_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estime el pago mensual de un préstamo o hipoteca, más el total que reembolsará y el interés, basado en el monto, la tasa y el plazo.`)
};

const de_ln_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechnen Sie die monatliche Rate für ein Darlehen oder eine Hypothek sowie den Gesamtbetrag und die Zinsen anhand von Betrag, Zinssatz und Laufzeit.`)
};

const nl_ln_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schat de maandelijkse betaling op een lening of hypotheek in, plus het totaal dat u terugbetaalt en de rente, op basis van het bedrag, de rente en de looptijd.`)
};

const fr_ln_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimez le paiement mensuel sur un prêt ou une hypothèque, plus le total que vous rembourserez et les intérêts, en fonction du montant, du taux et de la durée.`)
};

const it_ln_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stima il pagamento mensile su un prestito o mutuo, più il totale che ripagherai e l'interesse, in base all'importo, al tasso e alla durata.`)
};

const pt_br2_ln_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estime o pagamento mensal de um empréstimo ou hipoteca, além do total que você pagará e os juros, com base no montante, na taxa e no prazo.`)
};

const pt_ln_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estime o pagamento mensal num empréstimo ou hipoteca, mais o total que reembolsará e os juros, a partir do montante, da taxa e do prazo.`)
};

const ja_ln_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「ローンやモーゲージの月々の支払額、および合計返済額と利息を、金額、金利、期間から推定します。」`)
};

const zh_ln_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据贷款金额、利率和期限，估算贷款或房贷的月供，以及最终需偿还的总额和利息。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ln_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ln_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ln_intro", locale)
	if (locale === "en") return en_ln_intro(inputs)
	if (locale === "es") return es_ln_intro(inputs)
	if (locale === "de") return de_ln_intro(inputs)
	if (locale === "nl") return nl_ln_intro(inputs)
	if (locale === "fr") return fr_ln_intro(inputs)
	if (locale === "it") return it_ln_intro(inputs)
	if (locale === "pt-BR") return pt_br2_ln_intro(inputs)
	if (locale === "pt") return pt_ln_intro(inputs)
	if (locale === "ja") return ja_ln_intro(inputs)
	return zh_ln_intro(inputs)
};